import {http} from '@/utils'; // 暂时注释，等待真实接口

export type DailyBettingRankTypeParams = {
  group: 0;
  pageNo: number;
  pageSize: number;
  date: string;
};

export type DailyBettingRankTypeResponse = {
  rank: number;
  userId: string;
  username: string;
  userPhone: string;
  totalScore: number;
  rewardValue: number;
  userAvatar: string;
  rewardRate?: number;
  rewardRateStr?: string;
}[];

export type GetDailyBettingJackpotParams = {
  date: string;
};

export type GetDailyBettingJackpotResponse = number;

export type GetDailyBettingUserRankParams = {
  date: string;
};

export type GetDailyBettingUserRankResponse = {
  rank: number;
  userId: string;
  username: string;
  userPhone: string;
  totalScore: number;
  rewardValue: number;
  userAvatar: string;
  rewardRate?: number;
  rewardRateStr?: string;
};

export type GetTodayBettingDetailResponse = {
  /**
   * today 24:00:00 结束时间
   */
  countdownTime?: string;
  /**
   * 距离24:00:00 结束时间倒计时
   */
  countdownTimeStr?: string;
  /**
   * 排行榜最大奖励数
   */
  maxRank?: number;
  /**
   * 显示的积分
   */
  showScore?: number;
  /**
   * 固定展示文案1
   * 排行榜总奖励人数
   */
  showText1?: string;
  /**
   * 固定展示文案2
   * 距离上一名还差xx积分 或者  距离上榜还差xx积分
   */
  showText2?: string;
};

// 获取用户每日下注排行
export async function getDailyBettingRanking(
  params: Partial<DailyBettingRankTypeParams>,
) {
  try {
    return await http.post<
      DailyBettingRankTypeParams,
      DailyBettingRankTypeResponse
    >('/app/oldUserRank/getRank', params);
  } catch (err) {
    return [] as DailyBettingRankTypeResponse;
  }
}

// 每日下注奖金
export async function getDailyBettingJackpot(
  params: GetDailyBettingJackpotParams,
) {
  try {
    return await http.post<
      GetDailyBettingJackpotParams,
      GetDailyBettingJackpotResponse
    >('/app/oldUserRank/getJackpot', params);
  } catch (err) {
    return 0.0 as GetDailyBettingJackpotResponse;
  }
}

// 当前用户的每日下注排行
export async function getDailyBettingUserRank(
  params: GetDailyBettingUserRankParams,
) {
  try {
    return await http.post<
      GetDailyBettingUserRankParams,
      GetDailyBettingUserRankResponse
    >('/app/oldUserRank/getUserRank', params);
  } catch (err) {
    return {
      rank: 0,
      userId: '',
      username: '',
      userPhone: '',
      totalScore: 0.0,
      rewardValue: 0.0,
      rewardRate: 0.0,
      rewardRateStr: '0%',
    } as GetDailyBettingUserRankResponse;
  }
}

//  today 展示信息
export async function getTodayBettingDetail(): Promise<GetTodayBettingDetailResponse> {
  try {
    const response = await http.post('/app/oldUserRank/show/today');
    return response as GetTodayBettingDetailResponse;
  } catch (error) {
    console.error("Failed to get today's betting details:", error);
    // 返回默认值，确保组件不会因接口失败而崩溃
    return {
      countdownTime: '',
      countdownTimeStr: '',
      maxRank: 50,
      showScore: 0,
      showText1: '',
      showText2: '',
    };
  }
}

export type GetYesterdayRewardResponse = {
  /**
   * 活动名称
   */
  activityName?: string;
  /**
   * 昨日下注分数
   */
  betScore?: number;
  /**
   * 是否有昨日奖励
   */
  hasReward?: boolean;
  /**
   * 邀请人数
   */
  inviteCount?: number;
  /**
   * 昨日邀请分数
   */
  inviteScore?: number;
  /**
   * 昨日排名
   */
  rankPosition?: number;
  /**
   * 日期
   */
  rewardDate?: string;
  /**
   * 奖励状态：0-未发放，1-已发放
   */
  rewardStatus?: number;
  /**
   * 奖励状态描述
   */
  rewardStatusDesc?: string;
  /**
   * 奖励金额
   */
  rewardValue?: number;
  /**
   * 昨日总分数
   */
  totalScore?: number;
  /**
   * 用户ID
   */
  userId?: string;
  /**
   * 用户手机号
   */
  userPhone?: string;
};

export type GetPopupShowResponse = {
  /**
   * 积分邀请首充弹窗显示
   */
  inviteDepositShowFlag?: boolean;
  /**
   * 积分邀请首充弹窗奖励值
   */
  inviteDepositShowValue?: number;
  /**
   * 邀请首充人数
   */
  inviteDepositShowCount?: number;
  /**
   * 积分邀请弹窗显示
   */
  inviteShowFlag?: boolean;
  /**
   * 邀请人数
   * */
  inviteShowCount?: number;
  /**
   * 积分邀请弹窗奖励值
   */
  inviteShowValue?: number;
  /**
   * 参加过新用户无奖的用户弹窗显示
   */
  newUserRankNoRewardShowFlag?: boolean;
  /**
   * 参加过新用户且获奖的用户弹窗显示
   */
  newUserRankRewardShowFlag?: boolean;
};

export type GetYesterdayRewardAndPopupResponse = {
  rewardInfo: GetYesterdayRewardResponse;
  popupInfo: GetPopupShowResponse;
  regressionInfo: CheckRegressionResponse;
};

export type CheckRegressionResponse = {
  /** true 表示弹，false 表示不弹 banner */
  bannerFlag?: boolean;
  /** 回归用户积分加成比例 */
  bonusRate?: number;
  /** 回归倒计时终点时间 */
  regressionEndDate?: string;
  /** true 表示用户为回归用户，false 表示非 */
  regressionFlag?: boolean;
  /** 回归倒计时 */
  regressionTimeStr?: string;
  /** 用户ID */
  userId?: string;
};

// 默认值常量
const DEFAULT_REWARD_INFO: GetYesterdayRewardResponse = {
  activityName: '',
  betScore: 0,
  hasReward: false,
  inviteCount: 0,
  inviteScore: 0,
  rankPosition: 0,
  rewardDate: '',
  rewardStatus: 0,
  rewardStatusDesc: '',
  rewardValue: 0,
  totalScore: 0,
  userId: '',
  userPhone: '',
};

const DEFAULT_POPUP_INFO: GetPopupShowResponse = {
  inviteDepositShowFlag: false,
  inviteDepositShowValue: 0,
  inviteShowFlag: false,
  inviteShowValue: 0,
  newUserRankNoRewardShowFlag: false,
  newUserRankRewardShowFlag: false,
};

const DEFAULT_CHECK_REGRESSION_RESPONSE: CheckRegressionResponse = {
  bannerFlag: false,
  bonusRate: 1.0,
  regressionEndDate: '',
  regressionFlag: false,
  regressionTimeStr: '',
  userId: '',
};

// 查询用户昨日奖励信息（弹窗展示）
export async function getYesterdayReward(): Promise<GetYesterdayRewardResponse> {
  try {
    const response = await http.post('/app/oldUserRank/getYesterdayReward');
    return response as GetYesterdayRewardResponse;
  } catch (error) {
    // 返回默认值，确保组件不会因接口失败而崩溃
    return {
      activityName: '',
      betScore: 0,
      hasReward: false,
      inviteCount: 0,
      inviteScore: 0,
      rankPosition: 0,
      rewardDate: '',
      rewardStatus: 0,
      rewardStatusDesc: '',
      rewardValue: 0,
      totalScore: 0,
      userId: '',
      userPhone: '',
    };
  }
}

// 获取弹窗显示信息
export async function getPopupShow(): Promise<GetPopupShowResponse> {
  try {
    const response = await http.post('/app/oldUserRank/show/popup');
    return response as GetPopupShowResponse;
  } catch (error) {
    // 返回默认值，确保组件不会因接口失败而崩溃
    return {
      inviteDepositShowFlag: false,
      inviteDepositShowValue: 0,
      inviteDepositShowCount: 0,
      inviteShowFlag: false,
      inviteShowValue: 0,
      inviteShowCount: 0,
      newUserRankNoRewardShowFlag: false,
      newUserRankRewardShowFlag: false,
    };
  }
}

// 检查回归用户状态
export async function checkRegression(): Promise<CheckRegressionResponse> {
  try {
    const response = await http.post('/app/oldUserRank/check/regression');
    return response as CheckRegressionResponse;
  } catch (error) {
    return DEFAULT_CHECK_REGRESSION_RESPONSE;
  }
}

// 并行请求昨日奖励信息和弹窗显示信息
export async function getYesterdayRewardAndPopup(): Promise<GetYesterdayRewardAndPopupResponse> {
  try {
    const [rewardResult, popupResult, regressionResult] =
      await Promise.allSettled([
        getYesterdayReward(),
        getPopupShow(),
        checkRegression(),
      ]);

    let rewardInfo = DEFAULT_REWARD_INFO;
    let popupInfo = DEFAULT_POPUP_INFO;
    let regressionInfo = DEFAULT_CHECK_REGRESSION_RESPONSE;

    if (rewardResult.status === 'fulfilled') {
      rewardInfo = rewardResult.value;
    } else {
      console.error(
        "Failed to get yesterday's reward info:",
        rewardResult.reason,
      );
    }

    if (popupResult.status === 'fulfilled') {
      popupInfo = popupResult.value;
    } else {
      console.error('Failed to get popup display info:', popupResult.reason);
    }

    if (regressionResult.status === 'fulfilled') {
      regressionInfo = regressionResult.value;
    } else {
      console.error(
        'Failed to get regression user info:',
        regressionResult.reason,
      );
    }

    return {
      rewardInfo,
      popupInfo,
      regressionInfo,
    };
  } catch (error) {
    console.error(
      "Unexpected error when getting yesterday's reward and popup info:",
      error,
    );
    return {
      rewardInfo: DEFAULT_REWARD_INFO,
      popupInfo: DEFAULT_POPUP_INFO,
      regressionInfo: DEFAULT_CHECK_REGRESSION_RESPONSE,
    };
  }
}
